import { Fragment, useEffect, useState } from 'react';
import { useSelector, useDispatch} from 'react-redux';
import { Text } from '../../FormControls/Text';
import { Selector } from "../../FormControls/Selector";
import { List } from '../../FormControls/ListTransactions';
import {
  getListTrx,
} from "../../../../main/slices/storeSlice";
import { LoadingComponent } from '../../LoadingComponent';
import { COLORS } from '../../../styles/defaults';
import { useCookies } from "react-cookie";

export const History = ({ dimensions }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const [Transactions, setTransactions] = useState([]);
    const [filterTransactions, setFilterTransactions] = useState([]);

    //FUNCTION SEARCH
    const [cookies, setCookies] = useCookies();
    const [search, setSearch] = useState("");
    
    const statusTrx = {
        "nuevo": "new",
        "nueva": "new",
        "pendiente": "pending",
        "procesando": "processing",
        "rechazado": "rejected",
        "rechazada": "rejected",
        "completada": "completed",
        "completa": "completed",
        "finalizado": "completed",
        "fallido": "failed",
        "error": "failed",
        "expirada": "expired"
    };

    const normalizeStatus = (text) => {
        const key = text.trim().toLowerCase();
        return statusTrx[key] || key;
    };

    function transformApiData(apiData) {
        return apiData.map(item => ({ //FORMATO LIST ACTUAL
            id: item.id,
            Transaction_TimeStamp: new Date(item.createdTimestamp).toISOString(),
            Transaction_Type: "Venta",
            Transaction_Status: item.status || "",
            Transaction_Worldchain_Mined: true,
            Transaction_Deposit_Total: item.amountLocal,
            Transaction_Exchange_Rate_Country: 1,
            Transaction_Deposit_Currency: item.localCurrency,
            Transaction_Crypto_Currency: item.cryptoCurrency,
            Transaction_Crypto_Amount: item.amountCrypto,
            Transaction_Reference: item.qrData || "",
            Transaction_Hash_ID: item.qrLink || "",
            Bank_Name: "",
            Bank_Account_Name: "",
            Bank_Account_Number: "",
            Bank_Account_Currency: item.localCurrency,
            Bank_Account_Type: "Venta en Efectivo",
            Client_Name: item.store || "Tienda",
            Client_Lastname: "",
            Client_Email: "",
            Client_Phone_Number: "",
            Client_DPI: "",
            Device_Country: "Guatemala",
            Paid: item.paid,
            Transaction_Gift_Card: false,
            Bank_Data_Declined: false,
            Transaction_Modified: false
        }));
    }

    const store = useSelector(({ store }) => store);

    const getTrnsactios = async () => {
        await dispatch(getListTrx({
            "origin": "worldpos",
            "storeId": `${store.idStore.value}`,
        }))
        .unwrap()
        .then(({ response }) => {

            if (response.code==200) {
                const formatResponse= transformApiData(response.data);
                setTransactions(formatResponse); 
                setFilterTransactions(formatResponse);
            };
            setLoading(false)
        })
        .catch(e => {setLoading(false)});
        setLoading(false)
    }

    useEffect(() => {
        getTrnsactios();
    }, [dispatch]);

    const parseUserDate = (text) => {
        const regex = /^(\d{1,2})[\/\-\s](\d{1,2})[\/\-\s](\d{4})$/;

        const match = text.match(regex);
        if (!match) return null;

        const [_, day, month, year] = match;

        const date = new Date(`${year}-${month}-${day}T00:00:00`);
        return isNaN(date.getTime()) ? null : date.toISOString().slice(0,10); 
    };

    //SEARCH LIST FILTER
    const filterTrx = (text) => {
        const query = normalizeStatus(text.toLowerCase());
        const userDate = parseUserDate(text);

        if (query.trim() === "") {
            setFilterTransactions(Transactions);
            return;
        }

        const filtered = Transactions.filter((item) => {
            const fecha = new Date(item.Transaction_TimeStamp).toLocaleDateString(
                'es-ES',
                {
                    weekday: 'long',
                    day: '2-digit',
                    month: 'long',
                    year: 'numeric',
                    timeZone: 'GMT',
                }
            ).toLowerCase();
            
            const fechaISO = item.Transaction_TimeStamp.slice(0, 10);
            
            return (
                fecha.includes(query) ||
                item.id?.toString().includes(query) ||
                item.Transaction_Type?.toLowerCase().includes(query) ||
                item.Transaction_Status?.toLowerCase().includes(query) ||  // ahora soporta ES/EN
                item.Transaction_Deposit_Currency?.toLowerCase().includes(query) ||
                item.Transaction_Crypto_Currency?.toLowerCase().includes(query) ||
                item.Transaction_Crypto_Amount?.toString().includes(query) ||
                item.Transaction_Deposit_Total?.toString().includes(query) ||
                (userDate && fechaISO === userDate)
            );
        });

        setFilterTransactions(filtered);
    };
    
    // ACTION WITH USER WRITE INTO SEARCH INPUT
    useEffect(() => {
        const delay = setTimeout(() => {
            filterTrx(search);   // ejecutar filtro después de 1 segundo
        }, 500);

        return () => clearTimeout(delay);   // cancelar si el usuario sigue escribiendo
    }, [search, Transactions]);

    if(loading){
        return (
            <Fragment>
                <LoadingComponent />
            </Fragment>
        );
    }

    return (
        <Fragment>
            <div style={{ padding: "0 0.01rem" }}>
                {cookies.detalleTrx == true && 
                (<>
                    <Text classes={["title", "center"]}> {""} Lista de Transacciones {""}</Text>
                    <div style={{ marginBottom: "1rem" }}></div>
                    <input
                        type="text"
                        placeholder="Buscar Transacción..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        onFocus={(e) => {
                            e.target.style.border = '2px solid ' + COLORS.primary.acept;
                            e.target.style.backgroundColor = COLORS.primary.background;
                            e.target.style.outline = "none";
                        }}
                        style={{
                            width: "100%",
                            padding: "0.4rem",
                            fontSize: "1rem",
                            borderRadius: "20px",
                            borderColor: COLORS.primary.background,
                            backgroundColor: COLORS.primary.font,
                            border: "1px solid #ccc",
                            marginBottom: "1rem",
                        }}
                    />
                </>)
                }
                <div style={{ marginBottom: "0.01rem" }}></div>
                <List items={filterTransactions} />
            </div>
        </Fragment>
    )
}